import { takeLatest, takeEvery, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/DetallePedidoReducer/actions'
import * as layoutActions from '../../reducers/LayoutReducer/actions'
import * as Notification from '../../components/Common/notification'


function* genGetArticulo(e) {
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true }))

        // llamo a la acción que busca el artículo
        let articulo = yield calls.getArticulo(e.payload)

        if (!articulo || !articulo.idArticulo) {
            window.location.hash = '/'
            return
        }

        // almaceno los datos en el estado del reductor
        yield put(reducerActions.setArticulo(articulo))

        // si se pasó un pedido detalle como parámetro
        if (e.payload.idPedidoDetalle) {

            // busco los datos de pedido detalle
            let pedidoDetalle = yield calls.getPedidoDetalle(e.payload.idPedidoDetalle)

            // almecano los datos en el estado del reductor
            yield put(reducerActions.setPedidoDetalle(pedidoDetalle))
        }
    }
    catch (error) {
        // Un producto inexistente o no publicado no es un error visible para el usuario.
        window.location.hash = '/'
    }
    finally {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genGetArticulosRelacionados(e) {
    try {
        let articulos = yield calls.getArticulosRelacionados(e.payload)
        yield put(reducerActions.setArticulosRelacionados(articulos))
    }
    catch (error) {
        console.error('Error al recuperar artículos relacionados:', error)
    }
}

function* defaultSaga() {
    yield all([
        takeEvery(reducerActions.SAGA_FETCH_ARTICULO, genGetArticulo),
        takeEvery(reducerActions.SAGA_FETCH_ARTICULOS_RELACIONADOS, genGetArticulosRelacionados)
    ])
}

export const sagas = [
    defaultSaga
]